import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router'
import { App } from './app'
import './globals.css'

const incomingSignupKey = new URLSearchParams(window.location.search).get('key')
if (incomingSignupKey) {
  localStorage.setItem('etx_signup_key', incomingSignupKey)
}

createRoot(document.getElementById('root')!).render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
)

// Double-RAF waits for the first React paint before fading the bootloader splash,
// so the user never sees a frame where the splash is gone but the app isn't there yet.
requestAnimationFrame(() => {
  requestAnimationFrame(() => {
    const splash = document.getElementById('boot-splash')
    if (!splash) return
    splash.dataset.hide = 'true'
    setTimeout(() => splash.remove(), 400)
  })
})
